var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDescendingDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.82764,90.81482a4.00091,4.00091,0,0,1-5.65674.001L188,57.64905v86.34448a4,4,0,0,1-8,0V57.65L146.82861,90.82166a3.99975,3.99975,0,0,1-5.65674-5.65625l39.998-39.99854a4.02159,4.02159,0,0,1,.61231-.50024c.0957-.06372.19922-.10743.29882-.16211a2.32255,2.32255,0,0,1,.78467-.32788c.11768-.03492.23-.08008.35157-.10425a4.04074,4.04074,0,0,1,.73681-.07422c.01563-.00024.03027-.00464.0459-.00464.01758,0,.0332.00488.05078.00513a4.00334,4.00334,0,0,1,.73145.07373c.12207.02417.23535.06958.35351.10473a2.29348,2.29348,0,0,1,.772.321c.104.05664.21143.10254.311.16895a3.99967,3.99967,0,0,1,.54541.44506c.02.01929.04395.03223.064.05225l39.999,39.99316A4.00017,4.00017,0,0,1,226.82764,90.81482ZM48,131.99353h71.999a4,4,0,0,0,0-8H48a4,4,0,0,0,0,8Zm0-64h55.999a4,4,0,0,0,0-8H48a4,4,0,1,0,0,8Zm135.999,120H48a4,4,0,0,0,0,8H183.999a4,4,0,0,0,0-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescendingDark);
export default __webpack_public_path__ + "static/media/sort-descending-dark.8f4938b680fc0ca0f795dc96776f1978.svg";
export { ForwardRef as ReactComponent };